import { createReducer } from 'reduxsauce'
import { Types } from '../actions/movimentacaoActions'

const INITIAL_STATE = { error: false, loading: false, dados: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: true, dados: null }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: false, dados: action.payload }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, error: true, loading: false, dados: null }
}

const HANDLERS = {
    [Types.FETCH_MOVIMENTACAO_REPORT_BEGIN]: begin,
    [Types.FETCH_MOVIMENTACAO_REPORT_SUCCESS]: success,
    [Types.FETCH_MOVIMENTACAO_REPORT_FAILURE]: failure
}

export default createReducer(INITIAL_STATE, HANDLERS)